type ErrorDetail = {
  message: string;
  status: string;
};

export type ErrorTypes = {
  INVALID_INSTANCE: ErrorDetail;
  INSTANCE_DOES_NOT_SUPPORT_PROVIDER: ErrorDetail;
  UNKNOWN_ERROR: ErrorDetail;
  EMAIL_NOT_FOUND: ErrorDetail;
  APPLE_ID_HIDDEN: ErrorDetail;
  EMAIL_EXISTS: ErrorDetail;
  USER_NOT_FOUND: ErrorDetail;
};

export const ERRORS: ErrorTypes = {
  INVALID_INSTANCE: {
    message:
      "The instance provided is invalid or not recognized. Please verify the instance and try again.",
    status: "ERR1001",
  },
  INSTANCE_DOES_NOT_SUPPORT_PROVIDER: {
    message:
      "The specified instance does not support the selected provider. Please choose a compatible provider or contact support.",
    status: "ERR1002",
  },
  UNKNOWN_ERROR: {
    message:
      "An unknown error occurred. Please try again later or contact support if the problem persists.",
    status: "ERR1003",
  },
  EMAIL_NOT_FOUND: {
    message:
      "The email address provided could not be found. Please check the email and try again.",
    status: "ERR1004",
  },
  APPLE_ID_HIDDEN: {
    message:
      "The email address is hidden by Apple ID. Please use an alternative email or contact support.",
    status: "ERR1005",
  },
  EMAIL_EXISTS: {
    message:
      "The email address is already in use. Please use a different email or log in.",
    status: "ERR1006",
  },
  USER_NOT_FOUND: {
    message:
      "The user could not be found. Please check the provided information and try again.",
    status: "ERR1007",
  },
};
